import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandLessIcon from '@mui/icons-material/RemoveCircleOutline';
import ExpandIcon from '@mui/icons-material/AddCircleOutline';
import { baseLink, count } from '../config/helpers';
import dayjs from 'dayjs';
import Link from 'next/link';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Divider from '@mui/material/Divider';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const iconSx = {
    transition: 'color 0.2s ease-in-out',
    ':hover': {
        color: 'primary.main'
    }
}

const ArticleAccordion = ({idx, year, months, expanded, handleChange, type}) => {
    return (
        (<Accordion sx={{
            transition: 'color 0.2s ease-in-out',
            '&:hover': {
                // Target the first Typography within the Box with class 'year'
                '.year .MuiTypography-root:first-of-type': {
                    color: 'primary.main',
                },
            },
            '& .MuiAccordionSummary-root': {
                '&:hover .MuiSvgIcon-root': {
                    color: 'primary.main',
                }
            }
        }} expanded={String(expanded) === String(idx)} onChange={handleChange(idx)}>
            <AccordionSummary
            expandIcon={ (expanded == idx) ? <ExpandLessIcon color="primary" fontSize="large" /> : <ExpandIcon sx={iconSx} color="grey" fontSize="large" />}
            aria-controls={`${idx}-content`}
            id={`${idx}-header`}
            >
                <Box className="d-flex year">
                    <Link shallow={true} href={baseLink((type == 'blogpost' ? 'blog' : type) + '/' + year)}>
                        <Typography color={expanded == idx ? 'primary' : 'grey'} className="text-start fs-16" sx={{ width: '33%', flexShrink: 0}}>
                            {year}
                        </Typography>
                    </Link>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <>
                    {
                        count(Object.keys(months)) > 0 && Object.entries(months).map((key, index) => {
                            const date = key[0]; //date
                            const count = key[1]; //count of articles
                            return (
                                (<Box 
                                key={`${key}-${index}`}
                                sx={{
                                    p: 1,
                                }}>
                                    <Link shallow={true} href={baseLink((type == 'blogpost' ? 'blog' : type) + '/' + date)}>
                                        <Box sx={{
                                            transition: 'color 0.2s ease-in-out',
                                            '&:hover .MuiIconButton-root, &:hover .MuiTypography-root': {
                                                color: 'primary.main',
                                            },
                                        }} className="d-flex" key={index}>
                                            <IconButton className="p-0" color="grey" sx={{
                                                transition: 'color 0.2s ease-in-out',
                                                ':hover': {
                                                    color: 'primary.main'
                                                }
                                            }} variant="contained" aria-label="Read Article">
                                                <ArrowCircleRightOutlinedIcon  fontSize="medium" />
                                            </IconButton>
                                                    <Typography className="text-start f-size_2 p-1">{dayjs(date, 'YYYY/MM').format('MMMM YYYY')} ({count})</Typography>
                                        </Box>
                                        <Divider/>
                                    </Link>
                                </Box>)
                            );
                        })
                    }
                </>
            </AccordionDetails>
        </Accordion>)
    );
}

export default ArticleAccordion